// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/fundo-banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_cardLogin__OW3m6 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  border-radius: 12px;
}

.styles_divHeaderLogin__wUkTT {
  background-color: #18316e !important;
  width: 424px !important;
  height: 100px !important;
  margin-left: -40px !important;
  margin-top: -28px !important;
}

.styles_imgAltura__GvAhV {
  width: 80px !important;
  height: auto !important;
  margin-top: 16px !important;
  margin-left: 180px !important;
}

.styles_loginTextField__zarKA {
  margin-top: 48px !important;
  color: #18316e !important;
  font-family: "Inter";
}

.styles_senhaTextField__6-GPB {
  margin-top: 24px !important;
  color: #18316e !important;
  font-family: "Inter";
}

.styles_iconeUsuario__oxai0 {
  color: #fff;
  margin-top: 60%;
  transform: translateY(-50%);
  font-size: 28px !important;
}

.styles_fundoUsuario__ZLGMm {
  background-color: #18316e;
  width: 48px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin-left: -14px;
}

.styles_botaoAcessar__JwJUK {
  background-color: #18316e !important;
  margin-top: 32px !important;
  width: 100% !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
}

.styles_botaoAcessar__JwJUK:hover {
  transform: scale(0.95);
}

.styles_mensagemUsuario__sYske {
  font-family: "Inter" !important;
  color: #000000 !important;
}

body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: repeat;
  background-color: #e0e0e0;
  /* Cor de fundo do projeto, caso a imagem não carregue */
  height: 100vh;
  margin: 0;
}

.styles_botaoEsqueciSenha__oIstg {
  background-color: transparent !important;
  color: #043280 !important;
  margin-top: 20px !important;
  width: 100% !important;
  font-family: "Inter", sans-serif !important;
  border: none !important;
  cursor: pointer !important;
  text-decoration: none !important;
}

.styles_botaoEsqueciSenha__oIstg:hover {
  text-decoration: underline;
}

.styles_tituloPopup__dc7h5 {
  font-size: 28px !important;
  color: #0f2047 !important;
  font-family: "Abhaya Libre" !important;
}

.styles_tituloPopupContainer__JA\\+EU {
  display: flex !important;
  align-items: center !important;
}

.styles_botoesPopupGeral__0XvFK {
  margin-bottom: 20px !important;
  margin-right: 20px !important;
}

.styles_botaoPopupSalvar__OyWKo {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__OyWKo:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__jcgP3 {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__jcgP3:hover {
  transform: scale(0.95) !important;
}

.styles_emailEsqueciSenha__-WvKX {
  width: 400px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/RedefinirSenha/styles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yDAAsD;EACtD,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,wDAAwD;EACxD,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,2CAA2C;EAC3C,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".cardLogin {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 400px;\n  border-radius: 12px;\n}\n\n.divHeaderLogin {\n  background-color: #18316e !important;\n  width: 424px !important;\n  height: 100px !important;\n  margin-left: -40px !important;\n  margin-top: -28px !important;\n}\n\n.imgAltura {\n  width: 80px !important;\n  height: auto !important;\n  margin-top: 16px !important;\n  margin-left: 180px !important;\n}\n\n.loginTextField {\n  margin-top: 48px !important;\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.senhaTextField {\n  margin-top: 24px !important;\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.iconeUsuario {\n  color: #fff;\n  margin-top: 60%;\n  transform: translateY(-50%);\n  font-size: 28px !important;\n}\n\n.fundoUsuario {\n  background-color: #18316e;\n  width: 48px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  margin-left: -14px;\n}\n\n.botaoAcessar {\n  background-color: #18316e !important;\n  margin-top: 32px !important;\n  width: 100% !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoAcessar:hover {\n  transform: scale(0.95);\n}\n\n.mensagemUsuario {\n  font-family: \"Inter\" !important;\n  color: #000000 !important;\n}\n\nbody {\n  background-image: url('../../images/fundo-banner.png');\n  background-size: cover;\n  background-repeat: repeat;\n  background-color: #e0e0e0;\n  /* Cor de fundo do projeto, caso a imagem não carregue */\n  height: 100vh;\n  margin: 0;\n}\n\n.botaoEsqueciSenha {\n  background-color: transparent !important;\n  color: #043280 !important;\n  margin-top: 20px !important;\n  width: 100% !important;\n  font-family: \"Inter\", sans-serif !important;\n  border: none !important;\n  cursor: pointer !important;\n  text-decoration: none !important;\n}\n\n.botaoEsqueciSenha:hover {\n  text-decoration: underline;\n}\n\n.tituloPopup {\n  font-size: 28px !important;\n  color: #0f2047 !important;\n  font-family: \"Abhaya Libre\" !important;\n}\n\n.tituloPopupContainer {\n  display: flex !important;\n  align-items: center !important;\n}\n\n.botoesPopupGeral {\n  margin-bottom: 20px !important;\n  margin-right: 20px !important;\n}\n\n.botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.emailEsqueciSenha {\n  width: 400px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardLogin": `styles_cardLogin__OW3m6`,
	"divHeaderLogin": `styles_divHeaderLogin__wUkTT`,
	"imgAltura": `styles_imgAltura__GvAhV`,
	"loginTextField": `styles_loginTextField__zarKA`,
	"senhaTextField": `styles_senhaTextField__6-GPB`,
	"iconeUsuario": `styles_iconeUsuario__oxai0`,
	"fundoUsuario": `styles_fundoUsuario__ZLGMm`,
	"botaoAcessar": `styles_botaoAcessar__JwJUK`,
	"mensagemUsuario": `styles_mensagemUsuario__sYske`,
	"botaoEsqueciSenha": `styles_botaoEsqueciSenha__oIstg`,
	"tituloPopup": `styles_tituloPopup__dc7h5`,
	"tituloPopupContainer": `styles_tituloPopupContainer__JA+EU`,
	"botoesPopupGeral": `styles_botoesPopupGeral__0XvFK`,
	"botaoPopupSalvar": `styles_botaoPopupSalvar__OyWKo`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__jcgP3`,
	"emailEsqueciSenha": `styles_emailEsqueciSenha__-WvKX`
};
export default ___CSS_LOADER_EXPORT___;
